import React from 'react'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import { all_routes } from '../../router/all_routes';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import TestimonialSection from '../../home-one/testimonialSection';

const Testimonials = () => {
    const routes = all_routes
    const breadcrumbs = [
        {
            label: 'Testimonials',
            link: routes.home1,
            active: false,
        },
        {
            label: 'Pages',
            active: false,
        },
        {
            label: 'Testimonials',
            active: true,
        },
    ];
    return (
        <>
            <Breadcrumb title="Testimonials" breadcrumbs={breadcrumbs} backgroundClass="breadcrumb-bg-01" />
             <TestimonialSection />
        </>
    )
}

export default Testimonials